<template>
  <a
    class="half-full-size-teaser"
    :class="halfFullSizeTeaser.textColor ? halfFullSizeTeaser.textColor : ''"
    :href="halfFullSizeTeaser.link ? halfFullSizeTeaser.link.url : false"
    :target="halfFullSizeTeaser.link && halfFullSizeTeaser.link.openInNewWindow ? '_blank' : ''"
    :title="halfFullSizeTeaser.image.title"
  >
    <img
      class="half-full-size-teaser__img"
      :src="halfFullSizeTeaser.image.src"
      :alt="halfFullSizeTeaser.image.alt"
      :title="halfFullSizeTeaser.image.title"
      :width="halfFullSizeTeaser.image.width"
      :height="halfFullSizeTeaser.image.height"
      :loading="halfFullSizeTeaser.removeLazyLoading ? 'eager' : 'lazy'"
    >
    <div
      v-if="halfFullSizeTeaser.headline || halfFullSizeTeaser.text || halfFullSizeTeaser.button"
      class="half-full-size-teaser__content"
      :class="[
        textBgClass,
        halfFullSizeTeaser.textColor ? halfFullSizeTeaser.textColor : '',
        halfFullSizeTeaser.textDirection ? halfFullSizeTeaser.textDirection : 'left',
        halfFullSizeTeaser.transparent && textBgClass ? `${textBgClass}-gradient--${halfFullSizeTeaser.textDirection ? halfFullSizeTeaser.textDirection : 'left'} half-full-size-teaser__content--blur` : ''
      ]"
    >
      <h2
        v-if="halfFullSizeTeaser.headline"
        class="half-full-size-teaser__headline"
        v-html="halfFullSizeTeaser.headline"
      />
      <div
        v-if="halfFullSizeTeaser.text"
        class="half-full-size-teaser__text"
        :class="[
          halfFullSizeTeaser.sublineColor ? halfFullSizeTeaser.sublineColor : '',
        ]"
        v-html="halfFullSizeTeaser.text"
      />
      <div
        v-if="halfFullSizeTeaser.button"
        class="half-full-size-teaser__button--wrapper"
      >
        <button
          class="half-full-size-teaser__button"
          :class="[
            halfFullSizeTeaser.buttonBgColor ? `${halfFullSizeTeaser.buttonBgColor}`+` ${halfFullSizeTeaser.buttonBgColor}--hover` : 'button button--alt',
            halfFullSizeTeaser.buttonTextColor ? halfFullSizeTeaser.buttonTextColor : ''
          ]"
        >
          {{ halfFullSizeTeaser.button }}
        </button>
      </div>
    </div>
  </a>
</template>

<script>

  export default {
    props: {
      halfFullSizeTeaser: Object,
    },
    computed: {
      textBgClass() {
        if (this.halfFullSizeTeaser.textBgColor) {
          if (this.halfFullSizeTeaser.transparent) {
            return this.halfFullSizeTeaser.textBgColor.replace('bg-color-', 'bg-transparent-color-');
          }
          return this.halfFullSizeTeaser.textBgColor;
        }
      }
    }
  };

</script>
